import { AuthRepository } from "ftl-auth-module";
import { nanoid } from "nanoid";
export const getHeaders = () => {
    const headers = {
        "X-Device-Type": "WEB",
    };
    const token = AuthRepository.tokens.accessToken;
    if (token) {
        headers["X-Auth-Token"] = token;
    }
    if (localStorage.getItem("deviceToken")) {
        headers["X-Device-Token"] = localStorage.getItem("deviceToken");
    }
    else {
        const deviceToken = nanoid();
        headers["X-Device-Token"] = deviceToken;
    }
    return { common: Object.assign({}, headers) };
};
export function initializeParams(obj) {
    const params = [];
    Object.keys(obj).forEach((key) => {
        if (obj[key] || obj[key] === 0)
            params.push(`${key}=${obj[key]}`);
    });
    return params;
}
export default (repositoryInstance) => {
    function getWithParams(url, params = {}, defaultParams = {
        offset: 0,
        limit: 5,
        sortDirection: "DESC",
        sortName: "createdAt",
    }) {
        const p = initializeParams(Object.assign(Object.assign({}, defaultParams), params));
        return repositoryInstance.get(`${url}?${p.join("&")}`);
    }
    function switchActiveStatus(entityName, id) {
        return repositoryInstance.post(`${entityName}/${id}/active-status`);
    }
    function getDefault(entityName) {
        return repositoryInstance.get(`${entityName}/default`);
    }
    return Object.freeze({
        initializeParams,
        getWithParams,
        switchActiveStatus,
        getDefault,
    });
};
export const notImplementedFunc = () => Promise.reject("Not implemented");
//# sourceMappingURL=util.js.map